import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import ApiService from "../../Service/ApiService";
import { notify } from "../common/Toast";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../common/forms.css";

function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token) {
      notify("Reset link is missing or invalid. Please request a new one.", "error");
      return;
    }

    const { newPassword, confirmPassword } = formData;
    if (!newPassword || !confirmPassword) {
      notify("Please fill in all fields.", "error");
      return;
    }

    if (newPassword !== confirmPassword) {
      notify("Passwords do not match.", "error");
      return;
    }

    setLoading(true);
    const response = await ApiService.resetPassword(token, newPassword);
    if (response) {
      setFormData({ newPassword: "", confirmPassword: "" });
      navigate("/login", { replace: true });
    }
    setLoading(false);
  };

  return (
    <div className="form-page-container auth-form">
      <h2>Reset Password</h2>
      <p className="auth-helper-text">
        Choose a new password for your account.
      </p>
      {!token ? (
        <div className="auth-error-text">
          This reset link is missing a token. Request a new password reset email.
        </div>
      ) : null}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>New Password: </label>
          <div className="password-input-wrapper">
            <input
              type={showNewPassword ? "text" : "password"}
              name="newPassword"
              value={formData.newPassword}
              onChange={handleInputChange}
              required
            />
            <button
              type="button"
              className="toggle-password"
              onClick={() => setShowNewPassword((v) => !v)}
              aria-label={showNewPassword ? "Hide password" : "Show password"}
            >
              {showNewPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>
        <div className="form-group">
          <label>Confirm Password: </label>
          <div className="password-input-wrapper">
            <input
              type={showConfirmPassword ? "text" : "password"}
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleInputChange}
              required
            />
            <button
              type="button"
              className="toggle-password"
              onClick={() => setShowConfirmPassword((v) => !v)}
              aria-label={showConfirmPassword ? "Hide password" : "Show password"}
            >
              {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>
        <button
          type="submit"
          className={loading ? "disabled" : undefined}
          disabled={loading || !token}
        >
          {loading ? "Please wait..." : "Reset password"}
        </button>
      </form>
      <p className="register-link">
        Need a new link? <Link to="/forgot-password">Forgot password</Link>
      </p>
    </div>
  );
}

export default ResetPasswordPage;